import React from 'react'
import { BasicStatsItem } from '../index.styles'

const Coordination = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiMGVjYzBkYTItNjcwZi00YmY1LWJhMDctNDgwYzUxYTA5NTg0IiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="Coordination iframe" src={link} />
    </BasicStatsItem>
  )
}

export default Coordination